//Functions to add and remove classes as needed.
//Adds class to array item. Array is for element list for dropdown menu.
function addClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(" ");
  arr2 = name.split(" ");
  for (i = 0; i < arr2.length; i++) {
    if (arr1.indexOf(arr2[i]) == -1) {element.className += " " + arr2[i];}
  }
}

//Removes class for menu items for dropdown filter.
function removeClass(element, name) {
    var i, arr1, arr2;
    arr1 = element.className.split(" ");
    arr2 = name.split(" ");
    for (i = 0; i < arr2.length; i++) {
      while (arr1.indexOf(arr2[i]) > -1) {
        arr1.splice(arr1.indexOf(arr2[i]), 1);     
      }
    } 
    element.className = arr1.join(" ");
  }


//This will set the default display.
export function techStarter() {
    //Sets button start
    const filterElements = document.getElementsByClassName("filter-selector");
    let hashFilter = window.location.hash;
    let firstFilterValue;

    if(hashFilter){
      hashFilter = hashFilter.replace('#','');
      if(document.querySelector('.lib-type-class.'+hashFilter) && document.querySelector('.filter-selector[name="'+hashFilter+'"]')){
        firstFilterValue = hashFilter;
        const hashEl = document.querySelector('.filter-selector[name="'+hashFilter+'"]');
        addClass(hashEl, "active-tech-lib");
      }else{
        firstFilterValue = filterElements[0].attributes.value.value;
        addClass(filterElements[0], "active-tech-lib");
      }
    }else{
      firstFilterValue = filterElements[0].attributes.value.value;
      addClass(filterElements[0], "active-tech-lib");
    }

    let show = '';
    if(document.getElementsByClassName('location-cat-filter').length > 0) {
      show = 'location-show';
    } else {
      show = 'show';
    }

    //Sets all open filters
    const filterElementsAssets = document.getElementsByClassName(firstFilterValue);
    for (let i = 0; i < filterElementsAssets.length; i++) {
        addClass(filterElementsAssets[i], show);
    }
    let dropdownText = document.getElementsByClassName("active-tech-lib");
    document.getElementById('dropdownMenuButton').innerHTML = dropdownText[0].innerHTML;
}

//This function will allow toggling between sections.
export function techFilterSwitch(filter) {

    //Get current active button.
    const currentActiveButton = document.getElementsByClassName("active-tech-lib");

    //Remove activate class from current button
    removeClass(currentActiveButton[0], "active-tech-lib");

    //get new button
    const newActiveButton = document.getElementsByName(filter);
    //Apply active class to new button
    addClass(newActiveButton[0], "active-tech-lib");

    //For dropdown change button text
    let dropdownText = document.getElementsByClassName("active-tech-lib");
    document.getElementById('dropdownMenuButton').innerHTML = dropdownText[0].innerHTML;

    //Get current sections that have show
    const currentShowingFilter = document.getElementsByClassName("filterDiv");

    let show = '';
    if(document.getElementsByClassName('location-cat-filter').length > 0) {
      show = 'location-show';
    } else {
      show = 'show';
    }

    //Remove show class from current sections
    for(let i = 0; i < currentShowingFilter.length; i++) {
        removeClass(currentShowingFilter[i], show);
    }

    //Get new sections that have filter class
    const newShowingFilter = document.getElementsByClassName(filter);

    //Add show to these filters
    for(let i = 0; i < newShowingFilter.length; i++) {
        addClass(newShowingFilter[i], show);
    }

}